/**
 * 解析 wsKey
 */
export function parseWsKey(key: string) {
    const [uid, group, wsKey] = key.split('|');
    return {
        uid: +uid,
        group: +group,
        wsKey: +wsKey,
    };
}

/**
 * 获取随机颜色，确保与白色文字有足够的对比度
 */
export function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    let hasEnoughContrast = false;
    let isTooLight = true;

    // 如果对比度不够或颜色太浅，就重新生成
    while (!hasEnoughContrast || isTooLight) {
        color = '#';
        let r = 0,
            g = 0,
            b = 0;

        // 生成 RGB 值
        for (let i = 0; i < 6; i++) {
            const hex = letters[Math.floor(Math.random() * 16)];
            color += hex;

            // 计算 RGB 值
            if (i < 2) r = parseInt(hex, 16);
            else if (i < 4) g = parseInt(hex, 16);
            else b = parseInt(hex, 16);
        }

        // 检查是否太接近白色 (如果所有通道都大于 240，则认为太浅)
        isTooLight = r > 240 && g > 240 && b > 240;

        // 计算相对亮度 (使用 WCAG 2.0 标准)
        const r1 = r / 255;
        const g1 = g / 255;
        const b1 = b / 255;

        const r2 = r1 <= 0.03928 ? r1 / 12.92 : Math.pow((r1 + 0.055) / 1.055, 2.4);
        const g2 = g1 <= 0.03928 ? g1 / 12.92 : Math.pow((g1 + 0.055) / 1.055, 2.4);
        const b2 = b1 <= 0.03928 ? b1 / 12.92 : Math.pow((b1 + 0.055) / 1.055, 2.4);

        const L = 0.2126 * r2 + 0.7152 * g2 + 0.0722 * b2;

        // 白色文字的相对亮度是 1
        // 计算对比度比率 (白色文字亮度 / 背景色亮度)
        const contrastRatio = 1 / (L + 0.05);

        // 确保对比度至少为 4.5:1 (WCAG AA 标准)
        hasEnoughContrast = contrastRatio >= 4.5;
    }

    return color;
}
